import { queryClient } from '@metto/http-clients/api';
import { createRouteTree } from '@metto/ui-web/app/router';
import {
  createBrowserHistory,
  createRouter,
  RouterProvider
} from '@tanstack/react-router';

const routeTree = createRouteTree();

const router = createRouter({
  routeTree,
  history: createBrowserHistory(),
  context: {
    queryClient
  },
  defaultPreload: 'intent'
});

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router;
